import { type FC, type ElementType } from 'react';
import {
  uiStyles,
  UiButton,
  type UiButtonProps, UiStack, UiSpinner,
} from '@/lib/ui';
import { UiTooltip } from '@/lib/ui/Tooltip';
import BaseLoadingSpinner from '@/base/Loading/Spinner';
import { type IconProps } from '@phosphor-icons/react';

export interface PlainIconProps extends UiButtonProps {
  label: string
  Icon: ElementType
  color?: UiButtonProps['color']
  isLoading?: boolean
  iconSize?: IconProps['size']
  iconWeight?: IconProps['weight']
}

const PlainIcon: FC<PlainIconProps> = ({
  label,
  Icon,
  color = 'primary.500',
  isLoading = false,
  iconSize = '2xl',
  iconWeight = 'regular',
  ...props
}) => {
  if (isLoading) {
    return (
      <BaseLoadingSpinner />
    );
  }
  return (
    <UiTooltip label={label} borderRadius={uiStyles.borderRadius} py={1} px={3}>
      <UiButton
        variant={'ghost'}
        {...uiStyles.hover}
        {...props}
      >
        <Icon size={iconSize} color={color} weight={iconWeight} />
      </UiButton>
    </UiTooltip>
  );
};

export default PlainIcon;
